// /home/szymon/kreator2/frontend/src/components/MailTemplatesPanel.js
// v4.0.0 – Dodano pole "recipient" (odbiorca maila).

import React, { useState, useEffect, useRef } from "react";

export default function MailTemplatesPanel({ backendUrl }) {
  const [templates, setTemplates] = useState([]);
  const [error, setError] = useState("");

  // Pokazuje czy edytor unlayer jest widoczny
  const [showEditor, setShowEditor] = useState(false);

  // Pola do tworzenia/edycji
  const [templateId, setTemplateId] = useState(null); // null => nowy
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [recipient, setRecipient] = useState(""); // NOWE: odbiorca
  const editorRef = useRef(null);

  useEffect(() => {
    fetchTemplates();
    // eslint-disable-next-line
  }, []);

  function fetchTemplates() {
    fetch(`${backendUrl}/admin/mailtemplates`, { credentials: "include" })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Błąd pobierania szablonów maili.");
        }
        return res.json();
      })
      .then((data) => {
        setTemplates(data);
      })
      .catch((err) => {
        console.error("[MailTemplatesPanel] fetchTemplates =>", err);
        setError("Nie udało się pobrać listy szablonów.");
      });
  }

  // Gdy showEditor = true => inicjalizujemy unlayer
  useEffect(() => {
    if (showEditor && window.unlayer && editorRef.current) {
      window.unlayer.init({
        id: "editor-container",
        projectId: 269111, // wstaw swój projectId z unlayer
        displayMode: "email"
      });
    }
  }, [showEditor]);

  // Tworzenie nowego
  function handleCreateTemplate() {
    setError("");
    setTemplateId(null); // nowy
    setName("");
    setSubject("");
    setRecipient(""); // NOWE
    setShowEditor(true);
    setTimeout(() => {
      if (window.unlayer) {
        // reset design w unlayer
        window.unlayer.loadBlank();
      }
    }, 600);
  }

  // Edycja istniejącego
  function handleEditTemplate(id) {
    setError("");
    fetch(`${backendUrl}/admin/mailtemplates/${id}`, { credentials: "include" })
      .then((res) => {
        if (!res.ok) throw new Error("Błąd pobierania szablonu.");
        return res.json();
      })
      .then((tmpl) => {
        setTemplateId(tmpl.id);
        setName(tmpl.name || "");
        setSubject(tmpl.subject || "");
        setRecipient(tmpl.recipient || ""); // NOWE

        setShowEditor(true);

        setTimeout(() => {
          if (window.unlayer && tmpl.designJson) {
            try {
              const designObj = JSON.parse(tmpl.designJson);
              window.unlayer.loadDesign(designObj);
            } catch (ex) {
              console.error("[handleEditTemplate] JSON parse error =>", ex);
            }
          }
        }, 600);
      })
      .catch((err) => {
        console.error("[MailTemplatesPanel] handleEditTemplate =>", err);
        setError("Nie udało się pobrać danych szablonu.");
      });
  }

  // Usuwanie
  function handleDeleteTemplate(id) {
    if (!window.confirm("Czy na pewno usunąć ten szablon?")) return;
    fetch(`${backendUrl}/admin/mailtemplates/${id}`, {
      method: "DELETE",
      credentials: "include"
    })
      .then((res) => {
        if (!res.ok) throw new Error("Błąd usuwania szablonu.");
        return res.json();
      })
      .then(() => {
        fetchTemplates();
      })
      .catch((err) => {
        console.error("[handleDeleteTemplate]", err);
        setError("Nie udało się usunąć szablonu.");
      });
  }

  // Zapis
  function handleSaveTemplate() {
    setError("");
    if (!window.unlayer) {
      setError("Brak unlayer w window. Nie można zapisać.");
      return;
    }

    window.unlayer.exportHtml((data) => {
      const designJson = JSON.stringify(data.design);
      const htmlContent = data.html;

      const body = {
        name,
        subject,
        designJson,
        htmlContent,
        recipient // NOWE
      };

      let url = `${backendUrl}/admin/mailtemplates`;
      let method = "POST";

      if (templateId) {
        url = `${backendUrl}/admin/mailtemplates/${templateId}`;
        method = "PUT";
      }

      fetch(url, {
        method,
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("Błąd zapisu szablonu mailowego.");
          }
          return res.json();
        })
        .then((createdOrUpdated) => {
          setShowEditor(false);
          fetchTemplates();
        })
        .catch((err) => {
          console.error("[MailTemplatesPanel] handleSaveTemplate =>", err);
          setError("Nie udało się zapisać szablonu.");
        });
    });
  }

  if (showEditor) {
    return (
      <div className="orders-container" style={{ marginTop: "20px" }}>
        <h3>{templateId ? "Edytuj szablon" : "Nowy szablon"}</h3>
        {error && <p style={{ color: "red" }}>{error}</p>}

        <div style={{ marginBottom: 10 }}>
          <label style={{ marginRight: 8 }}>Nazwa szablonu:</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ padding: 6, marginRight: 20 }}
          />

          <label style={{ marginRight: 8 }}>Temat:</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            style={{ padding: 6 }}
          />
        </div>

        {/* NOWE pole Odbiorca */}
        <div style={{ marginBottom: 10 }}>
          <label>Odbiorca (recipient): </label>
          <input
            type="text"
            value={recipient}
            onChange={(e) => setRecipient(e.target.value)}
            placeholder='np. "biuro@amelia-wedding.pl" lub "{clientEmail}"'
            style={{ padding: 6, width: 280, marginLeft: 8 }}
          />
          <p style={{ fontSize: 12, color: "#777", margin: "4px 0" }}>
            Możesz wpisać stały adres lub placeholder. <br />
            {"{clientEmail}"} zostanie podmienione w trakcie wysyłki.
          </p>
        </div>

        <div
          id="editor-container"
          ref={editorRef}
          style={{ width: "100%", height: "600px", border: "1px solid #ccc" }}
        />

        <div style={{ marginTop: 10 }}>
          <button onClick={handleSaveTemplate} style={{ marginRight: 10 }}>
            Zapisz
          </button>
          <button onClick={() => setShowEditor(false)}>Anuluj</button>
        </div>
      </div>
    );
  }

  return (
    <div className="orders-container" style={{ marginTop: 20 }}>
      <h3>Lista Szablonów Mailowych</h3>
      {error && <p style={{ color: "red" }}>{error}</p>}

      <button
        className="orders-add-btn"
        style={{ marginBottom: 10 }}
        onClick={handleCreateTemplate}
      >
        Dodaj nowy szablon
      </button>

      {templates.length === 0 ? (
        <p>Brak szablonów w bazie.</p>
      ) : (
        <table className="orders-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nazwa</th>
              <th>Temat</th>
              <th>Odbiorca</th> {/* NOWA kolumna */}
              <th>Akcje</th>
            </tr>
          </thead>
          <tbody>
            {templates.map((t) => (
              <tr key={t.id}>
                <td>{t.id}</td>
                <td>{t.name}</td>
                <td>{t.subject}</td>
                <td>{t.recipient || "-"}</td> {/* Wypisujemy odbiorcę */}
                <td>
                  <button
                    style={{ marginRight: 6 }}
                    onClick={() => handleEditTemplate(t.id)}
                  >
                    Edytuj
                  </button>
                  <button onClick={() => handleDeleteTemplate(t.id)}>
                    Usuń
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
